import {Marker, Popup} from "react-leaflet";
import {memo} from "react";

const MapObjMarkers = (props) => {
    const {
        activePoints
    } = props;
    if (!activePoints || !activePoints.map) return null

    return (
        <>
            {activePoints.map((item) =>
                <Marker
                    key={item.id}
                    position={[item.point.x, item.point.y]}
                >
                    <Popup>
                        {item.name}
                    </Popup>
                </Marker>
            )}
        </>
    )
}

export default memo(MapObjMarkers)